module.exports = __webpack_public_path__ + "static/media/CHAP03-EXERGUE-BESOMBES.e9d14f40.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/CHAP03-EXERGUE-BESOMBES.png
// module id = 263
// module chunks = 0